import { render, staticRenderFns } from "./modalINSS.vue?vue&type=template&id=44cd4132&scoped=true&"
import script from "./modalINSS.vue?vue&type=script&lang=js&"
export * from "./modalINSS.vue?vue&type=script&lang=js&"
import style0 from "./modalINSS.vue?vue&type=style&index=0&id=44cd4132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cd4132",
  null
  
)

export default component.exports